import { Component, effect, EffectRef, ElementRef, inject, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { ButtonComponent } from "../../../../shared/button/button.component";
import { ButtonType } from '../../../../../models/enums/components/Button/ButtonType.enum';
import { NavigationService } from '@services/navigation.service';
import { DvmService } from '@services/dvm.service';
import { NavigationItem } from '@models/types/app/NavigationItem.type';
import anime from 'animejs';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import { MenuService } from '@services/components/menu.service';
import { SearchService } from '@services/components/search.service';

@Component({
    selector: 'app-home-button',
    imports: [ButtonComponent],
    templateUrl: './home-button.component.html',
    styleUrl: './home-button.component.css'
})
export class HomeButtonComponent {

  // VIEW CHILDS
  @ViewChild('homeBtn', { static: true, read: ElementRef })
  private readonly homeBtn!:    ElementRef<ButtonComponent>;

  // SERVICES
  private readonly history:     Signal<NavigationItem[]>   = inject(NavigationService).history;
  private readonly dvmService:  DvmService                 = inject(DvmService);
  private readonly menuService: MenuService                = inject(MenuService);
  private readonly searchService = inject(SearchService, { optional: true });

  // STATE
  public readonly showElement:  WritableSignal<boolean> = signal(false);
  
  // BUTTON
  public buttonType:            ButtonType          = ButtonType.Pill;

  // HISTORY UPDATE EFFECT
  public readonly onNavUpdate:  EffectRef           = effect((): void => {
    
    const history: NavigationItem[] | null = this.history(),
          view:    AppViews | null         = this.dvmService.view(),
          show:    boolean                 = history ? ( history.length > 2 || ( history.length > 1 && view === AppViews.Pano ) ) : false;  // Si el historial es mayor a 2, o si es mayor a uno pero la vista es 3d.
           
    
    if(history === null || view === null) return;

    anime({
        targets:  this.homeBtn.nativeElement,
        opacity:  show ? 1 : 0,
        duration: 300,
        easing:   'easeInOutQuad',
        complete: (): void => this.showElement.set(show),
    })
    

  });

  // METHODS
  public restartNavigation(): void {

    this.searchService?.clearFocusedSection();

    // Forzamos el seteo null de un menu item y asi limpiamos filtros y ams si hay
    this.menuService.setMenuItem(null);

    // Reseteamos el viewer
    this.dvmService.resetViewer();

  }

}
